var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFbLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 40 40"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M20 0C8.955 0 0 9 0 20.103c0 10.079 7.386 18.4 17.01 19.854V25.431h-4.947v-5.284h4.948V16.63c0-5.822 2.822-8.378 7.635-8.378 2.306 0 3.525.172 4.102.25v4.613h-3.283c-2.044 0-2.758 1.947-2.758 4.142v2.889h5.99l-.813 5.284h-5.177V40C32.47 38.669 40 30.28 40 20.103 40 9 31.046 0 20 0"
})));
export default SvgFbLogo;